var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.962 20C9.93134 20 8.16101 19.3367 6.65101 18.01C5.14167 16.684 4.26834 15.014 4.03101 13H5.04201C5.31401 14.72 6.09767 16.15 7.39301 17.29C8.68834 18.43 10.2113 19 11.962 19C13.912 19 15.566 18.321 16.924 16.963C18.282 15.605 18.9613 13.9507 18.962 12C18.9627 10.0493 18.2833 8.395 16.924 7.037C15.5647 5.679 13.9107 5 11.962 5C10.9267 5 9.95401 5.21867 9.04401 5.656C8.13401 6.09267 7.33067 6.69433 6.63401 7.461H9.11501V8.461H4.96201V4.309H5.96201V6.697C6.73534 5.84833 7.64134 5.187 8.68001 4.713C9.71867 4.239 10.8127 4.00133 11.962 4C13.0707 4 14.11 4.20867 15.08 4.626C16.05 5.04333 16.8973 5.61467 17.622 6.34C18.3467 7.06533 18.918 7.91267 19.336 8.882C19.754 9.85133 19.9627 10.8907 19.962 12C19.9613 13.1093 19.7527 14.1487 19.336 15.118C18.9193 16.0873 18.348 16.9347 17.622 17.66C16.896 18.3853 16.0487 18.9567 15.08 19.374C14.1113 19.7913 13.072 20 11.962 20ZM15.166 15.854L11.519 12.208V7H12.519V11.792L15.873 15.146L15.166 15.854Z",
    stroke: "#C5C6C9",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHistory);
export default __webpack_public_path__ + "static/media/ic_history.c5a888cd942a267a84d11b01252ebea3.svg";
export { ForwardRef as ReactComponent };